<template>
  <div class="d-flex flex-column-mobile px-3">
    <div class="col-md-2 filter-wrap" :class="{ show: isFilterOpen }">
      <div class="sticky-filters">
        <div class="justify-content-end align-items-center filter-close"  @click="toggleFilter">
          <span class="text-primary fw-bold">Κλείσιμο</span>
          <img src="../assets/images/close-icon.png" alt="Κλείσιμο φίλτρων" width="32">
        </div>
        <div class="search-wrap mt-xl-5 mt-3">
          <input
            id="search_input"
            v-model="searchValue"
            type="text"
            placeholder="Αναζήτηση..."
            class="form-control search-input"
          />
        </div>
        <div class="category-list my-3">
          <h5 class="category-list-title my-3">Κατηγορίες </h5>
          <div
            v-for="category in [{ id: null, title: 'ΟΛΕΣ' }, ...categories]"
            :key="category.id ?? 'all'"
            :class="['category-item', { active: activeCategory === category.id }]"
            @click="category.id === null ? clearFilters() : goToCategory(category.id)"
          >
            {{ category.title }}
          </div>
        </div>
        <div class="date-filter-wrap mt-3">
          <h5 class="date-filter-title mb-3">Ημερομηνία</h5>
          <div class="date-input-wrap">
            <div class="d-flex gap-2">
              <input
                type="text"
                class="date-input"
                id="startDate"
                v-model="startDate"
                placeholder="ηη/μμ/εεεε"
              />
              <input
                type="text"
                class="date-input"
                id="endDate"
                v-model="endDate"
                placeholder="ηη/μμ/εεεε"
              />
            </div>
            <button @click="filterByDate" class="date-filter-btn py-1 px-2 mt-3 bg-primary border-0 rounded text-white d-flex justify-content-between align-items-center w-100">Εφαρμογή Ημερομηνιών 
              <!-- <img  src="../assets/images/filter-icon.png"/> -->
              
            <img width="24" src="../assets/images/calendar-icon-v2.png"/>
            </button>
            <div class="mt-2">
              <button class="btn text-primary px-0 d-flex align-items-center fw-bold gap-1 clear-all-filters" @click="clearFilters()">
                <span class="bg-primary text-white fw-bold d-flex align-items-center justify-content-center" style="width: 16px;height: 16px;border-radius: 100%;">x</span> 
                Επαναφορά φίλτρων
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-xl-10 mb-5 cards-main-wrap">
      <div class="row mt-5 d-flex flex-wrap" v-if="filteredItems.length">
        <div class="mb-4 mb-xl-3 event-col " v-for="event in filteredItems" :key="event.id">
          <router-link :to="`/event/${event.id}`">
            <div class="card event-card position-relative">
              <div v-if="event.free_event && event.has_tickets == 0" class="free-label-wrap">
                  <p class="free-label">ΔΩΡΕΑΝ ΕΙΣΟΔΟς</p>
              </div>
              <div v-if="event.free_event && event.has_tickets == 1" class="free-label-wrap">
                  <p class="free-label">ΔΩΡΕΑΝ ΕΙΣΗΤΗΡΙΟ</p>
              </div>
              <div class="card-body-main d-flex flex-column position-relative">
                <div class="event-image-wrap">
                  <img class="event-image" :src="event.event_img_url" alt="Event image" />
                </div>
                <div class="eventInnerDesc">
                  <div class="d-flex align-items-center">
                    <div>
                      <span class="card-date fw-bold text-dark">
                        {{ event.earliest_date === event.latest_date
                          ? event.earliest_date
                          : event.earliest_date + ' - ' + event.latest_date }}
                      </span>
                    </div>
                  </div>
                  <div>
                    <p class="event-title fw-black text-dark">{{ event.title }}</p>
                  </div>
                  <div>
                    <span>{{ event.venue.title }}</span>
                  </div>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>

      <div v-else class="col-md-6 mb-3 mt-5">
        <p>Δεν βρέθηκαν αποτελέσματα.</p>
      </div>

      <nav aria-label="Page navigation" v-if="showPagination">
        <ul class="pagination mt-4">
          <li
            class="page-item"
            v-for="(paginationLink, index) in paginationLinks"
            :key="index"
            :class="{ active: paginationLink.active }"
          >
            <router-link
              v-if="paginationLink.url"
              :to="{ path: '', query: { ...filters, page: getPageFromUrl(paginationLink.url) } }"
            >
              <span class="page-link" v-html="paginationLink.label"></span>
            </router-link>
            <span v-else class="page-link" v-html="paginationLink.label"></span>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script setup>
  import { ref, computed, onMounted, watch, provide, inject } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { getEventCategories, fetchFilteredEvents } from '../services/events';
  import { useStore } from 'vuex'


  const data = ref([]);
  const paginationLinks = ref([]);
  const categories = ref([]);
  const activeCategory = ref(null);
  const searchValue = ref('');
  const startDate = ref(null);
  const endDate = ref(null);

  const route = useRoute();
  const router = useRouter();
  const store = useStore()

  function toggleFilter() {
    store.commit('toggleFilter');
  }

  provide('toggleFilter', toggleFilter)

 const isFilterOpen = computed(() => store.getters.isFilterOpen)


  const applyFilters = async () => {
    const filters = {
      search: route.query.search || undefined,
      category_id: route.query.category_id || undefined,
      start_date: route.query.start_date || undefined,
      end_date: route.query.end_date || undefined,
      page: route.query.page || 1,
    };

    const response = await fetchFilteredEvents(filters);
    if (response.data?.success) {
      data.value = response.data.data;
      paginationLinks.value = response.data.data.links || [];
    }
  };

  const filteredItems = computed(() => {
    const items = Array.isArray(data.value?.data) ? data.value.data : [];
    return items;
  });

  const setFilters = (filters) => {
    const query = Object.fromEntries(
      Object.entries(filters).filter(([_, v]) => v !== undefined)
    );
    router.push({ path: route.path, query });
  };

  const showPagination = computed(() => {
    return data.value && data.value.last_page > 1;
  });


  watch(
    () => route.query,
    () => {
      applyFilters();

      activeCategory.value = route.query.category_id
        ? parseInt(route.query.category_id)
        : null;
    },
    { immediate: true }
  );


  let searchTimeout;

  watch(searchValue, (newVal) => {
    if (searchTimeout) clearTimeout(searchTimeout);

    searchTimeout = setTimeout(() => {
      setFilters({
        ...route.query,
        search: newVal || undefined,
        page: 1
      });
    }, 500); 
  });

  const goToCategory = (id) => {
    setFilters({
      ...route.query,
      category_id: id,
      page: 1,
    });
  };

  const clearFilters = () => {
    searchValue.value = '';
    activeCategory.value = null;
    startDate.value = null;
    endDate.value = null;
    setFilters({});
  };

  const filterByDate = () => {
    setFilters({
      ...route.query,
      start_date: startDate.value,
      end_date: endDate.value,
      page: 1,
    });
  };

  const getPageFromUrl = url => {
    if (!url) return null;
    const urlObj = new URL(url, window.location.origin);
    return urlObj.searchParams.get('page');
  };

  onMounted(async () => {
    flatpickr("#startDate", {
      dateFormat: "d/m/Y",
      disableMobile: true,
    });

    flatpickr("#endDate", {
      dateFormat: "d/m/Y",
      disableMobile: true,
    });

    const categoriesResponse = await getEventCategories();
    if (categoriesResponse.data.success) {
      categories.value = categoriesResponse.data.data;
    }

    const categoryId = route.query.category_id;
    if (categoryId) activeCategory.value = parseInt(categoryId);
  });
</script>

<style scoped>

  .search-input {
    background-image: url("../assets/images/magnifrying-glass-icon.png");
    background-repeat: no-repeat;
    background-position: 5px center;
    padding-left: 40px;
    margin-top: 10px;
    border-radius: 10px;
    max-width: 90%;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
    transition: background-position 0.3s ease, box-shadow 0.3s ease;
  }

  .search-input:focus {
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.3);
    transform: translateY(-2px);
    outline: none;
    padding-left: 40px;
  }

  .filter-title {
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 20px;
  }

  .eventInnerDesc {
    background-color: #f1f1f1;
    padding-left:2px;
    padding-right: 2px;
  }

  .event-card {
    border-radius: 5px;
    background-color: transparent;
    box-shadow: 0 2px 4px rgba(0.3, 0.3, 0, 0.1);
    height: 100%;
    border-radius:15px;  
  }

  .event-col{
    flex:0 0 25%;
    max-width: 25%;
  }

  .card-date {
    font-size: smaller;
  }

  .clear-all-filters{
    margin-bottom: 25px;
  }

  .event-actions {
    position: absolute;
    bottom: -15px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    left: 0;
  }

  .card-body-main{
    border: 1px solid #383838;
    padding: 8px 12px;
    border-radius: 15px;
  }

  .card-body-main:hover {
    /* box-shadow: 0px 0px 10px 0px #c1c1c1; */
    transition: .5s;
    border: 1px solid var(--primary-color);
  }

  .event-card {
    position: relative;
    background: #f1f1f1;
  }

  .sold-out-banner {
    background-color: #dc3545;
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 1rem;
    font-size: 14px;
    max-width: 50%;
    animation: pulse 1.5s infinite;
    box-shadow: 0 0 10px rgba(220, 53, 69, 0.5);
  }

  .event-image-wrap {
    width: 100%;
    height: 130px;
    background-color: #e5e5e5;
    overflow: hidden;
  }

  .event-image {
    height: 100%;
    width: 100%;
    object-fit: contain;
    object-position: center center;
    display: block;
    margin: 0 auto;
  }

  .category-list {
    display: flex;
    flex-direction: column;
    position:relative;
  }

  .event-title{
    height: 32px;
    font-weight: 900;
    font-size: 14px;
    line-height: 1.1;
    margin-top: 2px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
  }

  .category-item {
    line-height: 2;
    cursor: pointer;
    border-radius: 4px;
    transition: background 0.2s;
    display: block;
    margin-left: 12px;
    padding: 4px 5px;
  }

  .category-item:hover{
    color: var(--primary-color);
    font-weight: bold;
  }

  .category-item:hover {
    background-color: #f0f0f0;
  }

  .category-item.active {
    font-weight: 500;
    position:relative
  }

  .category-item.active::before {
    content: "";
    position: absolute;
    left: -10px;        
    top: 10%;
    height: 80%;
    width: 5px;
    background-color: #af0036;
    border-radius: 10px;
  }

  .clear-filters{
    cursor: pointer;
    padding-left: 15px;
    margin-top:10px;
  }

  .category-list-title{
    font-weight: 500;
    background: var(--primary-color);
    color: white;
    width: fit-content;
    padding: 3px 8px;
    border-radius: 5px;
  }

  .cards-main-wrap{
    max-width: 1600px;
  }

  .date-input-wrap{
    width: 90%;
    gap: 10px;
  }

  .date-input{
    border-radius: 8px;
    background: transparent;
    color : var(--text-color);
    border: 1px solid var(--text-color);
    font-size: 12px;
    height:32px;
    text-align: center;
    width: 100%;
  }

  .date-input:focus-visible{
    outline-color: var(--primary-color);
  }
  

  .sticky-filters{
    position: sticky;
    top: 30px;
  }

  .filter-close{
    display: none;
  }

  .free-label-wrap {
    position: absolute;
    top: 5px;
    right: 5px;
    padding: 4px 10px;
    background: #22c55e;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    border-radius: 6px;
    text-transform: uppercase;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.08);
    z-index: 2;
  }

  .free-label{
    margin-bottom: 0;
  }

  
  @media (max-width: 1199px) {    
    .filter-wrap {
      position: fixed;
      z-index: 10;
      height: calc(100% - 28px);
      left: 0;
      border-right: 1px solid #ccc;
      background-color: var(--body-color);
      width: 260px;
      transform: translateX(-100%);
      opacity: 0;
      pointer-events: none;
      transition: transform 0.3s ease, opacity 0.3s ease;
      top: 0;
      z-index: 20;
      padding-left:10px;
      box-shadow: 0px 0px 40px 100px #a0a0a08f;
    }

    .filter-wrap.show {
      transform: translateX(3%);
      opacity: 1;
      pointer-events: auto;
    }
    .filter-close{
      display: flex;
    } 
  }


  @media (max-width: 992px) {
    .event-col{
      flex:0 0 33%;
      max-width: 33%;
    }
  }

  @media (max-width: 768px) {
   
    .event-image-wrap{
      height: 90px;
    }
  }


  @media (max-width: 576px) {
    .filter-wrap.show {
      transform: translateX(0%);
    }

    .event-title{
      height: 32px;
      overflow-y: hidden;
    }

    .event-col{
      flex:0 0 100%;
      max-width: 100%;
      margin: auto;
    }

    .event-image-wrap{
      height: 150px;
    }
  }

</style>